import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Form, Button, Spinner, Alert, Badge } from 'react-bootstrap';
import { FaFileExcel, FaSearch, FaFilter, FaSignOutAlt } from 'react-icons/fa';
import * as XLSX from 'xlsx';
import pythonApiClient from '../../../services/api/pythonBaseApi';

const ReporteCheckouts = () => {
    const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || 'null');
    
    const [checkouts, setCheckouts] = useState([]);
    const [estadisticas, setEstadisticas] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [zonas, setZonas] = useState([]);
    const [modulos, setModulos] = useState([]);
    const [filtros, setFiltros] = useState({
        zona_id: '',
        modulo_id: '',
        fecha_inicio: '',
        fecha_fin: ''
    });

    const loadReporte = async () => {
        if (!selectedProject?.id) return;

        setLoading(true);
        setError(null);
        try {
            // Preparar parámetros
            const params = {};

            if (filtros.fecha_inicio) params.fecha_inicio = filtros.fecha_inicio;
            if (filtros.fecha_fin) params.fecha_fin = filtros.fecha_fin;
            if (filtros.zona_id) params.zona_id = filtros.zona_id;
            if (filtros.modulo_id) params.modulo_id = filtros.modulo_id;

            const response = await pythonApiClient.get('/reportes/hoteleria/checkouts/', { params });

            if (response.data.success) {
                setCheckouts(response.data.data || []);
                setEstadisticas(response.data.estadisticas || null);
            } else {
                setError(response.data.message || 'No se pudo cargar el reporte');
            }
        } catch (error) {
            console.error("Error cargando reporte:", error);
            setError('No se pudo conectar con el servidor');
        } finally {
            setLoading(false);
        }
    };

    // Cargar al inicio
    useEffect(() => {
        if (selectedProject?.id) {
            loadZonas();
            loadReporte();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Solo ejecutar al montar el componente

    // Cargar módulos cuando cambia la zona
    useEffect(() => {
        if (filtros.zona_id) {
            loadModulos(filtros.zona_id);
        } else {
            setModulos([]);
            setFiltros(prev => ({ ...prev, modulo_id: '' }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filtros.zona_id]);

    const loadZonas = async () => {
        console.log('🔍 loadZonas - selectedProject:', selectedProject);
        console.log('🔍 loadZonas - selectedProject?.id:', selectedProject?.id);
        
        if (!selectedProject?.id) {
            console.error('❌ No hay proyecto seleccionado, no se pueden cargar zonas');
            return;
        }
        
        try {
            console.log('🌐 Llamando a /mantenimientos/zonas con proyecto_id:', selectedProject.id);
            const response = await pythonApiClient.get('/mantenimientos/zonas', {
                params: { proyecto_id: selectedProject.id },
                headers: { 'X-Proyecto-ID': selectedProject.id }
            });
            console.log('✅ Zonas cargadas:', response.data);
            setZonas(response.data || []);
        } catch (error) {
            console.error('❌ Error cargando zonas:', error);
            console.error('❌ Error response:', error.response?.data);
        }
    };

    const loadModulos = async (zonaId) => {
        try {
            const response = await pythonApiClient.get('/mantenimientos/modulos', {
                params: { zona_id: zonaId },
                headers: { 'X-Proyecto-ID': selectedProject.id }
            });
            setModulos(response.data || []);
        } catch (error) {
            console.error('Error cargando módulos:', error);
        }
    };

    const handleFilterChange = (field, value) => {
        setFiltros(prev => ({ ...prev, [field]: value }));
    };

    const handleSearch = () => {
        loadReporte();
    };

    const handleLimpiarFiltros = () => {
        setFiltros({
            zona_id: '',
            modulo_id: '',
            fecha_inicio: '',
            fecha_fin: ''
        });
    };

    const exportToExcel = () => {
        const dataToExport = checkouts.map(item => ({
            'ID': item.id,
            'DNI': item.dni,
            'Trabajador': item.trabajador,
            'Cargo': item.cargo || '-',
            'Proyecto': item.proyecto,
            'Zona': item.zona,
            'Módulo': item.modulo,
            'Habitación': item.habitacion,
            'Cama': item.cama,
            'Estado': item.estado,
            'Fecha Reserva': item.fecha_reserva_formateada,
            'Check-in': item.fecha_check_in_formateada,
            'Check-out': item.fecha_check_out_formateada,
            'Días Hospedado': item.dias_hospedado
        }));

        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Check-outs");
        XLSX.writeFile(wb, `Reporte_Checkouts_${new Date().toISOString().split('T')[0]}.xlsx`);
    };

    const formatFecha = (fechaStr) => {
        if (!fechaStr) return '-';
        try {
            return fechaStr;
        } catch (error) {
            return fechaStr;
        }
    };

    const getDiasHostBadgeVariant = (dias) => {
        if (dias <= 7) return 'success';
        if (dias <= 14) return 'primary';
        if (dias <= 21) return 'warning';
        return 'danger';
    };

    const getEstadoBadgeVariant = (estado) => {
        const estadoLower = (estado || '').toLowerCase();
        if (estadoLower.includes('finaliz')) return 'success';
        if (estadoLower.includes('activ')) return 'primary';
        return 'secondary';
    };

    if (!selectedProject) {
        return (
            <div className="dh-reporte-bg">
                <Container className="p-5">
                    <Alert variant="warning" className="dh-alert">
                        Por favor seleccione un proyecto para ver el reporte.
                    </Alert>
                </Container>
            </div>
        );
    }

    return (
        <>
            <style>
                {`
                    .dh-reporte-bg {
                        background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
                        min-height: 100vh;
                        padding: 2rem 0;
                    }
                    
                    .dh-card {
                        border: none;
                        border-radius: 20px;
                        box-shadow: 0 15px 35px rgba(0,0,0,0.1);
                        background: white;
                        margin-bottom: 2rem;
                    }
                    
                    .dh-card-header {
                        border-radius: 20px 20px 0 0;
                        padding: 1.25rem 1.5rem;
                        border: none;
                        font-weight: 700;
                        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                        color: white;
                    }
                    
                    .btn-dh-primary {
                        background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
                        border: none;
                        color: white;
                        border-radius: 10px;
                        padding: 10px 20px;
                        font-weight: 600;
                        font-size: 0.9rem;
                        box-shadow: 0 4px 14px rgba(17, 153, 142, 0.3);
                        transition: all 0.3s ease;
                    }
                    
                    .btn-dh-primary:hover {
                        background: linear-gradient(135deg, #38ef7d 0%, #2dd4bf 100%);
                        transform: translateY(-2px);
                        box-shadow: 0 8px 25px rgba(17, 153, 142, 0.4);
                        color: white;
                    }
                    
                    .btn-dh-secondary {
                        background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
                        border: none;
                        color: white;
                        border-radius: 10px;
                        padding: 10px 20px;
                        font-weight: 600;
                        font-size: 0.9rem;
                        box-shadow: 0 4px 14px rgba(107, 114, 128, 0.3);
                        transition: all 0.3s ease;
                    }
                    
                    .btn-dh-secondary:hover {
                        background: linear-gradient(135deg, #4b5563 0%, #374151 100%);
                        transform: translateY(-2px);
                        box-shadow: 0 8px 25px rgba(107, 114, 128, 0.4);
                        color: white;
                    }
                    
                    .btn-dh-success {
                        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
                        border: none;
                        color: white;
                        border-radius: 10px;
                        padding: 10px 20px;
                        font-weight: 600;
                        font-size: 0.9rem;
                        box-shadow: 0 4px 14px rgba(16, 185, 129, 0.3);
                        transition: all 0.3s ease;
                    }
                    
                    .btn-dh-success:hover {
                        background: linear-gradient(135deg, #059669 0%, #047857 100%);
                        transform: translateY(-2px);
                        box-shadow: 0 8px 25px rgba(16, 185, 129, 0.4);
                        color: white;
                    }
                    
                    .dh-form-control {
                        border: 2px solid #e5e7eb;
                        border-radius: 10px;
                        padding: 12px 16px;
                        font-size: 0.95rem;
                        transition: all 0.3s ease;
                        background: rgba(255, 255, 255, 0.9);
                    }
                    
                    .dh-form-control:focus {
                        border-color: #667eea;
                        box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
                        background: white;
                        outline: none;
                    }
                    
                    .dh-form-control:disabled {
                        background: #f3f4f6;
                        cursor: not-allowed;
                    }
                    
                    .dh-form-label {
                        color: #374151;
                        font-weight: 600;
                        font-size: 0.95rem;
                        margin-bottom: 8px;
                    }
                    
                    .dh-table {
                        margin-bottom: 0;
                    }
                    
                    .dh-table thead {
                        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                        color: white;
                    }
                    
                    .dh-table thead th {
                        border: none;
                        padding: 12px 16px;
                        font-weight: 600;
                        font-size: 0.875rem;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                    }
                    
                    .dh-table tbody tr {
                        transition: all 0.2s ease;
                    }
                    
                    .dh-table tbody tr:hover {
                        background-color: #f8f9fa;
                        transform: scale(1.01);
                    }
                    
                    .dh-table tbody td {
                        padding: 12px 16px;
                        border-color: #e5e7eb;
                        font-size: 0.9rem;
                        vertical-align: middle;
                    }
                    
                    .dh-stat-card {
                        border-radius: 15px;
                        padding: 1.5rem;
                        box-shadow: 0 4px 12px rgba(0,0,0,0.08);
                        transition: all 0.3s ease;
                    }
                    
                    .dh-stat-card:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 8px 20px rgba(0,0,0,0.12);
                    }
                `}
            </style>

            <div className="dh-reporte-bg">
                <Container fluid className="px-4">
                    <Card className="dh-card">
                        <Card.Header className="dh-card-header">
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaSignOutAlt className="me-3" size={24} />
                                    <div>
                                        <h4 className="mb-0">Reporte de Check-outs Realizados</h4>
                                        <small className="opacity-75">
                                            Proyecto: {selectedProject.nombre}
                                        </small>
                                    </div>
                                </div>
                                <Button
                                    className="btn-dh-success"
                                    onClick={exportToExcel}
                                    disabled={loading || checkouts.length === 0}
                                >
                                    <FaFileExcel className="me-2" />
                                    Exportar Excel ({checkouts.length})
                                </Button>
                            </div>
                        </Card.Header>
                        <Card.Body className="p-4">
                            {/* Filtros */}
                            <Card className="mb-4" style={{ border: '2px solid #e5e7eb', borderRadius: '15px' }}>
                                <Card.Body>
                                    <Row className="align-items-end">
                                        <Col md={2}>
                                            <Form.Group>
                                                <Form.Label className="dh-form-label">Zona</Form.Label>
                                                <Form.Select
                                                    className="dh-form-control"
                                                    value={filtros.zona_id}
                                                    onChange={(e) => handleFilterChange('zona_id', e.target.value)}
                                                >
                                                    <option value="">Todas</option>
                                                    {zonas.map(zona => (
                                                        <option key={zona.id} value={zona.id}>
                                                            {zona.nombre}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            <Form.Group>
                                                <Form.Label className="dh-form-label">Módulo</Form.Label>
                                                <Form.Select
                                                    className="dh-form-control"
                                                    value={filtros.modulo_id}
                                                    onChange={(e) => handleFilterChange('modulo_id', e.target.value)}
                                                    disabled={!filtros.zona_id}
                                                >
                                                    <option value="">Todos</option>
                                                    {modulos.map(modulo => (
                                                        <option key={modulo.id} value={modulo.id}>
                                                            {modulo.nombre}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group>
                                                <Form.Label className="dh-form-label">Fecha Check-out Inicio</Form.Label>
                                                <Form.Control
                                                    className="dh-form-control"
                                                    type="date"
                                                    value={filtros.fecha_inicio}
                                                    onChange={(e) => handleFilterChange('fecha_inicio', e.target.value)}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group>
                                                <Form.Label className="dh-form-label">Fecha Check-out Fin</Form.Label>
                                                <Form.Control
                                                    className="dh-form-control"
                                                    type="date"
                                                    value={filtros.fecha_fin}
                                                    onChange={(e) => handleFilterChange('fecha_fin', e.target.value)}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            <div className="d-flex gap-2 flex-column">
                                                <Button
                                                    className="btn-dh-primary w-100"
                                                    onClick={handleSearch}
                                                    disabled={loading}
                                                >
                                                    <FaSearch className="me-2" />
                                                    Buscar
                                                </Button>
                                                <Button
                                                    className="btn-dh-secondary w-100"
                                                    onClick={handleLimpiarFiltros}
                                                    disabled={loading}
                                                >
                                                    <FaFilter className="me-2" />
                                                    Limpiar
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>

                            {/* Mensajes de error */}
                            {error && (
                                <Alert variant="danger" onClose={() => setError(null)} dismissible>
                                    {error}
                                </Alert>
                            )}

                            {/* Estadísticas */}
                            {estadisticas && (
                                <Row className="mb-4">
                                    <Col md={3}>
                                        <Card className="dh-stat-card text-center border-0" style={{ background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)' }}>
                                            <Card.Body>
                                                <h3 className="text-primary mb-0">{estadisticas.total_checkouts}</h3>
                                                <small className="text-muted fw-bold">Check-outs Realizados</small>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="dh-stat-card text-center border-0" style={{ background: 'linear-gradient(135deg, rgba(17, 153, 142, 0.1) 0%, rgba(56, 239, 125, 0.1) 100%)' }}>
                                            <Card.Body>
                                                <h3 className="text-info mb-0">{estadisticas.trabajadores_distintos}</h3>
                                                <small className="text-muted fw-bold">Trabajadores Únicos</small>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="dh-stat-card text-center border-0" style={{ background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.1) 100%)' }}>
                                            <Card.Body>
                                                <h3 className="text-success mb-0">{estadisticas.promedio_dias_hospedado}</h3>
                                                <small className="text-muted fw-bold">Promedio Días Hospedado</small>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={3}>
                                        <Card className="dh-stat-card text-center border-0" style={{ background: 'linear-gradient(135deg, rgba(251, 191, 36, 0.1) 0%, rgba(245, 158, 11, 0.1) 100%)' }}>
                                            <Card.Body>
                                                <h3 className="text-warning mb-0">{estadisticas.total_dias_acumulados}</h3>
                                                <small className="text-muted fw-bold">Total Días Acumulados</small>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            )}

                            {/* Loading */}
                            {loading && (
                                <div className="text-center p-5">
                                    <Spinner animation="border" variant="primary" />
                                    <p className="mt-3 text-muted">Cargando check-outs realizados...</p>
                                </div>
                            )}

                            {/* Mensaje sin datos */}
                            {!loading && checkouts.length === 0 && (
                                <Alert variant="info">
                                    No se encontraron check-outs con los filtros seleccionados.
                                </Alert>
                            )}

                            {/* Tabla de resultados */}
                            {!loading && checkouts.length > 0 && (
                                <div style={{ borderRadius: '15px', overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
                                    <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
                                        <Table striped bordered hover className="dh-table mb-0">
                                            <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>DNI</th>
                                                    <th>Trabajador</th>
                                                    <th>Cargo</th>
                                                    <th>Zona</th>
                                                    <th>Módulo</th>
                                                    <th>Habitación</th>
                                                    <th>Cama</th>
                                                    <th>Estado</th>
                                                    <th>Fecha Reserva</th>
                                                    <th>Check-in</th>
                                                    <th>Check-out</th>
                                                    <th>Días Hospedado</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {checkouts.map((checkout, index) => (
                                                    <tr key={index}>
                                                        <td>{checkout.id}</td>
                                                        <td>{checkout.dni}</td>
                                                        <td>{checkout.trabajador}</td>
                                                        <td>{checkout.cargo || '-'}</td>
                                                        <td>{checkout.zona}</td>
                                                        <td>{checkout.modulo}</td>
                                                        <td>{checkout.habitacion}</td>
                                                        <td>
                                                            <Badge bg="secondary">{checkout.cama}</Badge>
                                                        </td>
                                                        <td>
                                                            <Badge bg={getEstadoBadgeVariant(checkout.estado)}>
                                                                {checkout.estado}
                                                            </Badge>
                                                        </td>
                                                        <td>
                                                            <small>{formatFecha(checkout.fecha_reserva_formateada)}</small>
                                                        </td>
                                                        <td>
                                                            <small>{formatFecha(checkout.fecha_check_in_formateada)}</small>
                                                        </td>
                                                        <td>
                                                            <small className="fw-bold text-success">
                                                                {formatFecha(checkout.fecha_check_out_formateada)}
                                                            </small>
                                                        </td>
                                                        <td>
                                                            <Badge bg={getDiasHostBadgeVariant(checkout.dias_hospedado)}>
                                                                {checkout.dias_hospedado} días
                                                            </Badge>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            )}
                        </Card.Body>
                    </Card>
                </Container>
            </div>
        </>
    );
};

export default ReporteCheckouts;
